import React, { useState, useEffect } from "react";

import Button from "src/components/Common/Buttons/Button";
import { groupStyles } from "src/utils/SelectStyles";
import Select from "react-select";
import { isEmpty } from "src/utils/helpers";

export function defineActionButton(
  action,
  label,
  faIcon = null,
  disabled = false,
  children = null
) {
  return { action, label, faIcon, disabled, children };
}

export default function DefaultDashboardSearch({
  disabled,
  onInputChange,
  actionButtons,
  onAction,
  children = undefined,
  inputPlaceholder = "Name or Description...",
  hasMoreOptions = true,
  showDownloadButton = true,
  showSelectDropdown = false,
  dropDownData = [],
  filters = [],
  hideSecondaryActionButtons = false,
}) {
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showActionDropDown, setShowActionDropDown] = useState(false);
  const [selectedLogStream, setSelectedLogStream] = useState(null);


  const dropDownOptions = dropDownData.map((item) => ({
    label: item,
    value: item,
  }));

  useEffect(() => {
    if (
      dropDownOptions.length > 0 &&
      (!selectedLogStream ||
        !dropDownOptions.some(opt => opt.value === selectedLogStream.value))
    ) {
      setSelectedLogStream(dropDownOptions[0]);
    }
  }, [dropDownOptions]);

  const buttons = {
    default: defineActionButton("SEARCH", "Search", "fa-search"),
    secondary: [defineActionButton("ADD", "New", "fa-plus")],
    dropdown: defineActionButton("DOWNLOAD", "Download", "fa-download"),
    dropdownItems: [
      defineActionButton("XLS", "As XLS"),
      defineActionButton("CSV", "As CSV"),
    ],
    ...(actionButtons || {}),
  };

  return (
    <div className="cmv-container-dashboard-search">
      <div className="cmv-container-dashboard-filter">
        <div className="container">
          <div className="form-row">
            <div className="col-md-4">
              {showSelectDropdown &&
                <Select
                  className="extra-filter-select"
                  styles={groupStyles}
                  placeholder={"Please Select a Log Stream"}
                  options={dropDownOptions}
                  defaultValue={dropDownOptions[0]}
                  value={selectedLogStream}
                  onChange={(option) => setSelectedLogStream(option)}
                />

              }
            </div>
            <div className={`${showSelectDropdown ? 'col-md-8' : 'col-md-12'}`}>
              <div className="input-group">
                <input
                  placeholder={inputPlaceholder}
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  onChange={onInputChange}
                  onKeyUp={(event) => {
                    if (event.key === 'Enter') {
                      if (window.location.pathname === '/system/logs') {
                        onAction('SEARCH', selectedLogStream?.value ?? '');
                      } else {
                        onAction('SEARCH');
                      }
                    }
                  }}
                />
                <div className="input-group-append">
                  <Button
                    type="button"
                    className="btn btn-primary btn-show-cam-search-results"
                    disabled={disabled || buttons.default.disabled}
                    onClick={() => onAction(buttons.default.action, selectedLogStream?.value ?? "")}
                  >
                    {buttons.default.faIcon && (
                      <i className={`fas ${buttons.default.faIcon}`} />
                    )}
                    <span>&nbsp;{buttons.default.label}</span>
                  </Button>
                </div>

                <div className="input-group-append">
                  <div className="btn-group">
                    {hasMoreOptions && (
                      <Button
                        type="button"
                        onClick={() => setShowMoreOptions(!showMoreOptions)}
                        className="btn btn-outline-secondary position-relative"
                        title={"More Filters"}
                      >
                        <i
                          className={`fas fa-solid ${
                            showMoreOptions ? " fa-ban" : "fa-filter"
                          }`}
                        />
                        <span>&nbsp;Filters</span>
                        {/*{!isEmpty(filters) && (*/}
                        {/*  <span*/}
                        {/*    className="badge badge-primary position-absolute"*/}
                        {/*    style={{*/}
                        {/*      top: "-5px",*/}
                        {/*      right: "-5px",*/}
                        {/*      fontSize: "0.6rem",*/}
                        {/*      padding: "0.2rem 0.4rem",*/}
                        {/*      borderRadius: "100%",*/}
                        {/*      zIndex: 10,*/}
                        {/*      color: "white"*/}
                        {/*    }}*/}
                        {/*  >*/}
                        {/*    1*/}
                        {/*  </span>*/}
                        {/*                    )}*/}
                                          </Button>
                                        )}


                    {!hideSecondaryActionButtons && buttons.secondary.map((btn) => (
                      <button
                        key={`ct2_ds_s_${btn.action}`}
                        type="button"
                        className="btn btn-outline-secondary btn-new-account-wizard"
                        disabled={disabled || btn.disabled}
                        onClick={() => onAction(btn.action)}
                        title={btn.label}
                      >
                        {btn.faIcon && <i className={`fas ${btn.faIcon}`} />}
                        <span>&nbsp;{btn.label}</span>
                      </button>
                    ))}

                    {showDownloadButton && buttons.dropdownItems && (
                      <div className="dropdown">
                        <button
                          type="button"
                          className="btn btn-outline-secondary dropdown-toggle"
                          onClick={() =>
                            setShowActionDropDown(!showActionDropDown)
                          }
                          disabled={disabled}
                        >
                          {buttons.dropdown.faIcon && (
                            <i className={`fa ${buttons.dropdown.faIcon}`} />
                          )}
                          <span className="camvio-table-search-download">
                            &nbsp;{buttons.dropdown.label}
                          </span>
                        </button>
                        <div
                          className={
                            "dropdown-menu dropdown-menu-right" +
                            (showActionDropDown && !disabled ? " show" : "")
                          }
                        >
                          {buttons.dropdownItems.map((btn) => (
                            <button
                              key={`ct2_ds_drp_${btn.action}`}
                              type="button"
                              className="dropdown-item"
                              onClick={(e) => {
                                onAction(btn.action);
                                setShowActionDropDown(false);
                              }}
                            >
                              {btn.faIcon && (
                                <i className={`fas ${btn.faIcon}`} />
                              )}
                              <span>&nbsp;{btn.label}</span>
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showMoreOptions && (
        <div className="cmv-container-dashboard-filter">
          <div className="container">
            <div className="camvioTable-plan-extra-filters">{children}</div>
          </div>
        </div>
      )}
    </div>
  );
}
